export type HttpResponse<T> = ResponseOk<T> | Error | undefined;
export type ResponseOk<T> = { data: T };
export type ResponseNok = { errorCode: string; errorMessages: string };

export function unwrap<T>(response: HttpResponse<T>): T {
    return (response as ResponseOk<T>).data;
}
